import React, { useMemo, useState } from 'react';
import { listaGarantias } from '../../models/garantias';
import { useGarantias } from '../../hooks/useGarantias';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import ActionMenu, { Action } from '../../../../components/ui/materialui/actionMenu';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { usePermissions } from '../../../../components/auth/ProtectedRoute';
import { TipoFuncionalidad } from '../../../../utils/enums';
import { useDetalleMutuoAccess } from '../../../../components/auth/DetalleMutuoPermissionGuard';

interface IProps {
    idGarantias: number;
    idMutuo: number;
    obtenerGarantias: (idMutuo: number, idGarantias: number) => Promise<void>;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    garantias: listaGarantias;
    renderizar: () => Promise<void>;
    isComplementario: boolean;
    isDesactivado?: boolean;
    esVigente?: boolean;
}

const AccionesGarantias: React.FC<IProps> = (props) => {
    const { garantias, renderizar } = props;
    const { eliminarGarantias } = useGarantias();
    const { hasAccess: puedeVer } = useDetalleMutuoAccess(
        props.esVigente,
        undefined,
        [TipoFuncionalidad.Bandeja_ver, TipoFuncionalidad.Cartera_ver]
    );

    // Validar si puede eliminar (solo Bandeja_editar)
    const { hasAccess: puedeEliminarPorPermiso } = useDetalleMutuoAccess(
        props.esVigente,
        TipoFuncionalidad.Bandeja_editar
    );
    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => {
        },
    });
    async function handleEditParticipante() {
        props.setShow(true);
        await props.obtenerGarantias(props.idMutuo, props.idGarantias);
    }

    const handleDeleteSeguro = async () => {
        setModalConfirmacion({
            show: true,
            title: 'Eliminar seguro',
            message: `¿Estás seguro de eliminar la garantía ${garantias.tipoBienRaiz.toLowerCase()} rol: ${garantias.rol}?`,
            metodo: () => {
                eliminarGarantias(props.idMutuo, props.idGarantias, renderizar);
            },
        });
    }

    const actions = useMemo<Action[]>(() => {
        const items: Action[] = [];

        if (puedeVer) {
            items.push({
                label: 'Ver garantía',
                icon: <SearchIcon fontSize="small" />,
                onClick: handleEditParticipante,
            });
        }

        // Validación completa: permiso + condiciones de negocio
        const puedeEliminar = puedeVer 
            && !props.isComplementario
            && !props.isDesactivado;

        if (puedeEliminar) {
            items.push({
                label: 'Eliminar garantía',
                icon: <ClearIcon fontSize="small" />,
                onClick: handleDeleteSeguro,
            });
        }

        return items;
    }, [
        puedeVer,
        puedeEliminarPorPermiso,
        props.isComplementario,
        props.isDesactivado,
        props.idGarantias,
        props.idMutuo
    ]);

    return (
        <>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({
                        ...modalConfirmacion,
                        show: false,
                    })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />
            <ActionMenu actions={actions} />

        </>

    );
};

export default AccionesGarantias;
